import { Grid, styled } from '@mui/material';

export const GridWrapper = styled(Grid)({
  '.recharts-wrapper .recharts-cartesian-grid-horizontal line:first-of-type, .recharts-wrapper .recharts-cartesian-grid-horizontal line:last-child, .recharts-wrapper .recharts-cartesian-grid-vertical line:last-child, .recharts-wrapper .recharts-cartesian-grid-vertical line:first-of-type':
    {
      strokeOpacity: 0,
    },
});
